<template>
  <span>
    <div class="machine-information-headline" :data-machine="result.maschinenbezeichnung">
      {{ result.maschinenbezeichnung }}
    </div>
    <ul>
      <li :key="`descriptionIndex_${descriptionIndex}`" v-for="(description, descriptionIndex) in result.description">
        <span class="circle-number">{{ description.number }}</span><span class="description-text">{{ description.text }}</span>
      </li>
    </ul>
    <div v-if="ab_test != true && hidePrices != true">
      <div
        v-if="
          financeTypeLength !== 1 ||
            financeType[0] === 'Noch nicht sicher' ||
            financeType[0] === 'Pay per Cup'
        "
        class="price-block"
      >
        <div
          v-if="result['preis-kauf'] !== result['streichpreis-kauf']"
          class="price-old"
        >
          Ab € {{ result['streichpreis-kauf'] }} oder mtl. €
          {{ result['streichpreis-miete'] }}
        </div>
        <div
          class="price"
          v-bind:class="{
            'price-new': result['preis-kauf'] !== result['streichpreis-kauf']
          }"
        >
          Ab €
          <span class="price-value">{{ result['preis-kauf'] }}</span>
          oder mtl. €
          <span class="price-value">{{ result['preis-miete'] }}<sup>*</sup></span>
          zzgl. MwSt.
        </div>
      </div>
      

      <div
        v-if="financeTypeLength === 1 && financeType[0] === 'Kauf'"
        class="price-block price-block-selling"
      >
        <div
          v-if="result['preis-kauf'] !== result['streichpreis-kauf']"
          class="price-old"
        >
          Ab € {{ result['streichpreis-kauf'] }}
        </div>
        <div
          class="price"
          v-bind:class="{
            'price-new': result['preis-kauf'] !== result['streichpreis-kauf']
          }"
        >
          Ab €
          <span class="price-value">{{ result['preis-kauf'] }}<sup>*</sup></span
          >zzgl. MwSt.
        </div>
      </div>

      <div
        v-if="financeTypeLength === 1 && financeType[0] === 'Miete und Leasing'"
        class="price-block price-block-renting"
      >
        <div
          v-if="result['preis-miete'] !== result['streichpreis-miete']"
          class="price-old"
        >
          Ab € {{ result['streichpreis-miete'] }}
        </div>
        <div
          class="price"
          v-bind:class="{
            'price-new': result['preis-miete'] !== result['streichpreis-miete']
          }"
        >
          Ab €
          <span class="price-value">{{ result['preis-miete'] }}<sup>*</sup></span
          >zzgl. MwSt. mtl.
        </div>
      </div>
    </div>
  </span>
</template>

<script>
export default {
  props: {
    result: {
      type: Object,
      default: () => {}
    },
    financeTypeLength: {
      type: Number,
      default: 0
    },
    financeType: {
      type: [String, Array]
    },
    ab_test: {
      type: Boolean
    },
    hidePrices: {
      type: Boolean
    }
    
  }
}
</script>
